import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import mapl from "../../assets/img/map-location.svg";
import arrow from "../../assets/img/arrow.svg";
import './Panel.styles.scss';
import { getAllStrokes, getDetail, getRoutes, getStroke, getUnitPosition } from "./Panel.service";
import { decrypt } from "../../utilities/Encriptacion";
import camion from "../../assets/img/camion.png";
import bus from "../../assets/img/bus.png";
import sprinter from "../../assets/img/sprinter.png";
import hiace from "../../assets/img/hiace.png";
import avanza from "../../assets/img/avanza.png"
import UnitDetailModal from "../../components/molecules/UnitDetail/UnitDetailModal";
import Map from "../../components/molecules/Map/Map";
import {Polyline, Marker, Popup} from "react-leaflet";
import L from "leaflet";
import markerImage from '../../assets/img/red_icon.png'
import Sidebar from "../../components/organisms/Sidebar/Sidebar";

interface Position {
    lat: number;
    lng: number;
}

interface Route {
    ID: number | null;
    NOMBRE: string | null;
    CHOFER: number | null;
    ID_UNIDAD: number | null;
    ID_TRAZO: number | null;
    TIPO: number | null;
    ID_BITACORA: number | null;
}
interface IMarker extends Position {
    stop: string;
    time: string;
}

interface StrokeData {
    markers: { marker: IMarker }[];
    stroke: Position[];
    strokeColor: string;
    routeName: string
}

interface UnitPosition {
    position: Position,
    unit: string,
    id: number,
}

interface Detail {
    CHOFER: string
    UNIT: string
    OP_IMG: string
    UNIT_IMG: string
}

const Panel = () => {
    const [routes, setRoutes] = useState<Route[]>([]);
    const [name, setName] = useState<string | null>(null);
    const [unitId, setUnitId] = useState<number | null>(null);
    const [routeId, setRouteId] = useState<number | null>(null);
    const [routeIdTrazo, setRouteIdTrazo] = useState<number | null>(null);
    const [routeIdBitacora, setRouteIdBitacora] = useState<number | null>(null);
    const [getUnit, setGetUnit] = useState(true);
    const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
    const [strokes, setStrokes] = useState<StrokeData[]>([]);
    const [defaultCenter] = useState<Position>({ lat: 20.67129241646564, lng: -103.35232101509537 });
    const [unitPosition, setUnitPosition] = useState<UnitPosition | null>(null);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [detail, setDetail] = useState<Detail | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showTime, setShowTime] = useState(true);
    const [selectedRoute, setSelectedRoute] = useState<{name: string, index: number} | null>(null);
    const location = useLocation();
    const [busType, setBusType] = useState<number | null>(3);
    const [isOn, setIsOn] = useState(true);

    const camionImages = {
        1: hiace,
        2: sprinter,
        3: camion,
        4: bus,
        6: camion,
        7: avanza
    };

    const getCamionIcon = (tipo: number | null) => {
        // @ts-ignore
        return camionImages[tipo] || camion;
    };

    const markerUnidad = new L.Icon({
        iconUrl: getCamionIcon(busType), // Reemplaza con tu imagen
        iconSize: [40, 22], // Tamaño del icono
        iconAnchor: [16, 25], // Punto de anclaje (centro en la base del ícono)
        popupAnchor: [0, -32], // Punto donde el popup aparece, relativo al ícono
    });

    const markerPersonalizado = (
        item: { marker: { time: string } },
        key: number,
        showTime: boolean
    ) => {
        return L.divIcon({
            className: "custom-marker",
            html: `
      <img style="width:40px;position:relative" src="${markerImage}" alt="marker"/>
      <div style="position:absolute;top:12px;left:${key < 10 ? "17px" : "14.5px"};font-weight:bold;font-size:0.6rem">${key}</div>
      <!--<div style="width:max-content;padding: 2px 5px; 
      display: ${showTime ? "block" : "none"};
      border-radius: 10px;
      background: rgba(0,0,0,0.5);
      margin-right: 20px;
      position: absolute;
      top: 42px;
      left: 0;">
          <div style="
              color: white;
              font-size: 11px;">
              ${item.marker.time}
          </div>
      </div>-->
    `,
            iconSize: [25, 41], // Tamaño del icono
            iconAnchor: [20, 40], // Punto de anclaje
        });
    };

    useEffect(() => {
        const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION;
        const dataClient = sessionStorage.getItem('dataClient');
        if (dataClient) {
            const id = decrypt(dataClient, CLAVE);
            getRoutes(setRoutes, JSON.parse(id).id, isOn);
        }
    }, [isOn]);

    useEffect(() => {
        setIsSubMenuOpen(false);
    }, [location]);

    const toggleSubMenu = () => {
        setIsSubMenuOpen(!isSubMenuOpen);
    };

    const handleRouteClick = (id: number | null, name: string | null, unitId: number | null, id_trazo: number | null, tipo: number | null, id_bitacora: number | null) => {
        if (id === null && name === "TODAS LAS RUTAS") {
            setName("TODAS LAS RUTAS");
            setUnitId(null);
            getAllStrokes(setStrokes, setUnitPosition, isOn);
            setShowTime(false);
            setSearchTerm('');
            setGetUnit(false);
            sessionStorage.removeItem('rutaId');
            setSelectedRoute(null);
        } else if (id !== null) {
            setName(name);
            setUnitId(unitId);
            setRouteId(id);
            setRouteIdTrazo(id_trazo);
            setRouteIdBitacora(id_bitacora)
            //@TODO CAMBIAR PARA QUE BUSQUE POR ESTRUCTURA
            getStroke(setStrokes, id, id_trazo);
            setSearchTerm('');
            setGetUnit(true);
            setBusType(tipo)
            sessionStorage.setItem('rutaId', id.toString());
            setSelectedRoute(null);
        }
    };

    useEffect(() => {
        if (getUnit) {
            const fetchData = async () => {
                await getUnitPosition(unitId, routeIdBitacora,setUnitPosition, setGetUnit);
            };

            fetchData();
            const interval = setInterval(fetchData, 10000);

            return () => clearInterval(interval);
        }

    }, [unitId, getUnit, routeId, routeIdTrazo]);


    const filteredRoutes = routes.filter(route =>
        route.NOMBRE?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const showDetail = (id: number) => {
        getDetail(id, setDetail);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setDetail(null);
        setIsModalOpen(false);
    }

    const handlePolylineClick = (routeName: string, index: number) => {
        setSelectedRoute({name: routeName, index: index});
        setName(routeName);
    }

    const toggleSwitch = () => {
        setIsOn(!isOn);
    };

    return (
        <div>
            { routeId && (
                <Sidebar
                    idBitacora={routeIdBitacora}
                    idTrazo={routeIdTrazo}
                />
            )}
            <div className="nav-item">

                <img src={mapl} alt={'map'}/>
                <span>Rutas</span>
                <div className="switch-container">
                    <div
                        className={`switch ${isOn ? 'on' : 'off'}`}
                        onClick={toggleSwitch}
                    >
                        <div className="switch-slider">
                            <span className="switch-label">
                                {isOn ? 'E' : 'S'}
                            </span>
                        </div>
                    </div>
                </div>

                <img src={arrow} alt={'arrow'} onClick={toggleSubMenu}/>

                <div className={`submenu ${isSubMenuOpen ? 'is-open' : ''}`}>
                    <input
                        type="text"
                        placeholder="Buscar ruta..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                        onClick={(e) => e.stopPropagation()}
                    />
                    <div className="route-item">
                        <span onClick={() => {
                            setIsSubMenuOpen(false);
                            handleRouteClick(null, "TODAS LAS RUTAS", null, null, null, null)
                        }}>TODAS LAS RUTAS</span>
                    </div>
                    {filteredRoutes.map((route, index) => (
                        <div key={index} className="route-item">
                            <span
                                onClick={() => {
                                    setIsSubMenuOpen(false);
                                    handleRouteClick(route.ID, route.NOMBRE, route.ID_UNIDAD, route?.ID_TRAZO, route.TIPO, route.ID_BITACORA)
                                }}>
                                {route.NOMBRE}
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            <Map
                center={defaultCenter}
                zoom={10}
                scrollWheelZoom={true}
                style={{height: 'calc(100vh - 68px)', width: '100%', zIndex: "0"}}
                onClick={undefined}
            >
                {strokes.map((route, routeIndex) => (
                    <React.Fragment key={routeIndex}>
                        {/* Renderiza la polilínea de la ruta */}
                        <Polyline pathOptions={{ color: route.strokeColor }} positions={route.stroke} eventHandlers={{
                            click: () => {
                                handlePolylineClick(route.routeName, routeIndex);
                            },
                        }}/>

                        {/* Mostrar marcadores solo si la ruta está seleccionada o si es la única */}
                        {(selectedRoute?.index === routeIndex || strokes.length === 1) && (
                            route.markers.map((marker, index) => (
                                <Marker
                                    key={index}
                                    position={marker.marker}
                                    icon={markerPersonalizado(marker, index + 1, showTime)}
                                >
                                    <Popup>
                                        <div className={'info-window'} >
                                            <h3>Parada {index + 1}</h3>
                                            <p className={'p-name'}>
                                                <strong style={{color: '#4285F4'}}>Nombre:</strong> {marker.marker.stop}
                                            </p>
                                            <p className={'p-time'}>
                                                <strong style={{color: '#4285F4'}}>Hora de llegada:</strong> {marker.marker.time}
                                            </p>
                                        </div>
                                    </Popup>
                                </Marker>
                            ))
                        )}
                    </React.Fragment>
                ))}
                <React.Fragment>
                    {unitPosition && (
                        <Marker position={unitPosition.position} icon={markerUnidad} eventHandlers={{
                            click: () => {
                                showDetail(unitPosition.id);
                            },
                        }}></Marker>
                    )}
                </React.Fragment>
            </Map>
            {name && (
                <div className="route-name-container">
                    <span>{name}</span>
                </div>
            )}
            {detail ?
                <UnitDetailModal
                    isOpen={isModalOpen}
                    onClose={closeModal}
                    driverPhoto={detail.OP_IMG}
                    unitPhoto={detail.UNIT_IMG}
                    driver={detail.CHOFER}
                    unit={detail.UNIT}
                /> : ''}
            {selectedRoute && (
                <div className="route-name-container">
                    {selectedRoute.name}
                </div>
            )}
        </div>
    );
};

export default Panel;